/**
 * KIM Account RPC Definitions
 */

import { Rpc, RpcGroup } from "effect/rpc";
import {
  GetKimAccountsRequestSchema,
  GetKimAccountsResponseSchema,
} from "../schemas/kimaccount/index";
import { ExternalAPIErrorSchema } from "../errors";

export class KimAccountRpcs extends RpcGroup.make(
  Rpc.make("KimAccountList", {
    success: GetKimAccountsResponseSchema,
    error: ExternalAPIErrorSchema,
    payload: GetKimAccountsRequestSchema,
  })
) {}
